import { render, staticRenderFns } from "./admin-tm-room.vue?vue&type=template&id=d12a8c00&"
import script from "./admin-tm-room.vue?vue&type=script&lang=js&"
export * from "./admin-tm-room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports